export default "__VITE_ASSET__BS1gu6dL__"